export default __webpack_public_path__ + "static/media/confirmed-icon.dd374b07.svg";